import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {Receiver} from '../../core/_models'
import {FormattedMessage} from 'react-intl'
import {ModalNotification} from '../../../../../modules/custom/modals/ModalNotification'
import {initialQueryState} from '../../../../../../_metronic/helpers'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<Receiver>>
  notePopup?: HTMLElement
}
const ReceiverCustomHeader: FC<Props> = ({className, title, tableProps, notePopup}) => {
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    // avoid sorting for these columns
    console.log('id', isSelectedForSorting)

    if (id === 'actions' || id === 'selection') {
      return
    }

    // if (!isSelectedForSorting) {
    //   // enable sort asc
    //   updateState({...initialQueryState, sort: id, order: 'asc'})
    //   return
    // }

    if (order !== undefined) {
      if (order === 'asc') {
        // enable sort desc
        updateState({...initialQueryState, sort: id, order: 'desc'})
        return
      } else {
        updateState({...initialQueryState, sort: id, order: 'asc'})
        return
      }

      // // disable sort
      // updateState({...initialQueryState, sort: undefined, order: undefined})
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && order !== undefined && `table-sort-${order}`
      )}
      style={{cursor: 'pointer'}}
      onClick={sortColumn}
    >
      {notePopup && (
        <div className='d-flex'>
          <span className='me-1'>
            <FormattedMessage id={title} />
          </span>{' '}
          <ModalNotification
            svg='/media/icons/duotune/general/gen046.svg'
            addClass='ModalNotification__position'
            children={notePopup}
          />
        </div>
      )}
      {!notePopup && title && <FormattedMessage id={title} />}
    </th>
  )
}

export {ReceiverCustomHeader}
